import React from "react";

import { Icon, IconProps } from "../";

export const CommentTypingLineIcon = (props: IconProps) => {
  return (
    <Icon {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M21.7 20.3L19.7 18.3C21.2 16.5 22 14.3 22 12C22 6.5 17.5 2 12 2C6.5 2 2 6.5 2 12C2 17.4068 6.34875 21.8472 11.7212 21.9961L12 22H21C21.3 22 21.5 21.9 21.7 21.7C22.0692 21.3308 22.0976 20.7911 21.7852 20.3957L21.7 20.3ZM3.5 12C3.5 16.5884 7.19404 20.3647 11.7528 20.4964L12.0104 20.5H19.7787L17.6707 18.392L18.5477 17.3397C19.8262 15.8054 20.5 13.9441 20.5 12C20.5 7.32843 16.6716 3.5 12 3.5C7.32843 3.5 3.5 7.32843 3.5 12ZM7 12C7 12.6 7.4 13 8 13C8.6 13 9 12.6 9 12C9 11.4 8.6 11 8 11C7.4 11 7 11.4 7 12ZM12 13C11.4 13 11 12.6 11 12C11 11.4 11.4 11 12 11C12.6 11 13 11.4 13 12C13 12.6 12.6 13 12 13ZM15 12C15 12.6 15.4 13 16 13C16.6 13 17 12.6 17 12C17 11.4 16.6 11 16 11C15.4 11 15 11.4 15 12Z"
      />
    </Icon>
  );
};
